<template>
  <div class="flex flex-col items-center justify-center min-h-screen gap-4 text-center px-6">
    <p class="text-6xl font-bold text-gray-300">404</p>
    <h1 class="text-xl font-semibold text-gray-700">{{ $t('notFound.title') }}</h1>
    <p class="text-sm text-gray-500">{{ $t('notFound.desc') }}</p>
    <router-link to="/" class="mt-2 text-sm text-blue-600 hover:underline">{{ $t('notFound.goHome') }}</router-link>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

let metaTag

onMounted(() => {
  metaTag = document.createElement('meta')
  metaTag.name = 'robots'
  metaTag.content = 'noindex'
  document.head.appendChild(metaTag)
})

onUnmounted(() => {
  metaTag?.remove()
})
</script>
